"use client"

import dynamic from "next/dynamic"
import type { SerializedEditorState } from "@/components/shared/lexical-editor-wrapper"

const EditorViewer = dynamic(
  () => import("@/components/shared/EditorViewer").then((m) => m.EditorViewer),
  { ssr: false }
)

export function EditorViewerClient({
  editorSerializedState,
}: {
  editorSerializedState: SerializedEditorState
}) {
  return <EditorViewer editorSerializedState={editorSerializedState} />
}
